export enum FORMAT_TYPES {
  money = 'money',
};

export type ItemFormat = {
  column: string,
  format: FORMAT_TYPES,
};